import { render, staticRenderFns } from "./ErrorValidations.vue?vue&type=template&id=18f4a098&"
import script from "./ErrorValidations.vue?vue&type=script&lang=js&"
export * from "./ErrorValidations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports